import React from "react"
import { RenderElementProps } from "slate-react"

const QuoteTextImageBottom = ({ children, attributes }: RenderElementProps) => {
    return (
        <p {...attributes} className="text-sm md:text-md lg:text-lg">
            {children}
        </p>
    )
}

export default QuoteTextImageBottom
